import styled from '@emotion/styled';
import css from '@styled-system/css';
import { pick } from '@styled-system/props';
import Close from 'imagesUwKluis/svg/close.svg';
import {CSSProperties, FC} from 'react';
import * as ReactModal from 'react-modal';
import theme from '../../../../../theme';
import { useMediaQuery } from '@dnhb/node_package';
import { Box, Flex } from '../../../../shared/layouts';

const CloseButton = styled.button({
  backgroundColor: 'inherit',
  border: 0,
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  width: '32px',
  height: '32px'
});

const modalStyling = {
  boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.12)',
  minHeight: '128px',
  borderRadius: 0,
  border: 0,
  padding: 0
};

const desktopPositioning: CSSProperties = {
  position: 'fixed',
  top: '50%',
  right: 'auto',
  bottom: 'auto',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 80px)',
  maxWidth: '1040px',
  height: 'calc(100% - 64px)'
};

const mobilePositioning: CSSProperties = {
  position: 'absolute',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
  borderTop: '1px solid #D3DDE0'
};

interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  appElement?: HTMLElement;
}

const Modal: FC<ModalProps> = ({
  isOpen = false,
  onRequestClose,
  appElement = document.body,
  children,
  ...boxProps
}) => {
  const isMinDesktop = useMediaQuery('(min-width: 900px)');
  const contentStyle = isMinDesktop ? desktopPositioning : mobilePositioning;

  return (
    <ReactModal
      appElement={appElement}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          zIndex: 101
        },
        content: {
          ...modalStyling,
          ...contentStyle,
          ...css(pick(boxProps))(theme)
        }
      }}
    >
      <Box
        bg="white"
        css={{
          position: 'relative',
          boxSizing: 'border-box',
          minHeight: '100%',
          height: '100%',
          width: '100%',
          padding: 0
        }}
      >
        {!isMinDesktop && (
          <Flex
            justifyContent="flex-end"
            alignItems="center"
            height="72px"
            p="0 16px"
            borderBottom="default"
          >
            <CloseButton onClick={() => onRequestClose()}>
              <Close
                css={({ colors }) => ({ fill: colors.secondaryFont })}
                width="2rem"
                height="2rem"
                display="block"
              />
            </CloseButton>
          </Flex>
        )}
        {children}
      </Box>
    </ReactModal>
  );
};

export default Modal;
